export default __webpack_public_path__ + "static/media/no-leave-request-artwork.15933f9d.svg";